import React from 'react';
import { SymbolInfoDataMessage } from 'widgets/symbolInfo/SymbolInfoDataMessage';
import Tooltip from 'utils/components/Tooltip/Tooltip';
import './SymbolInfoCapsuleContent.scss';
import { DetailsPanel } from 'utils/components/DetailsPanel/DetailsPanel';

interface SymbolInfoCapsuleContentProps {
    data?: SymbolInfoDataMessage;
}
export function SymbolInfoCapsuleContent(props: SymbolInfoCapsuleContentProps) {
    const { data } = props;

    if (!data) {
        return <div className="SymbolInfoCapsuleContent">No data</div>;
    }

    return (
        <DetailsPanel className="SymbolInfoCapsuleContent">
            <Tooltip neverHide={true} text={data.name} showDelay={200}>
                <div className="title">{data.name}</div>
            </Tooltip>
            <div className="value">{data.sect}</div>
            <div className="value">{data.country}</div>
        </DetailsPanel>
    );
}
